import script from "./PublicLoginKindChoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicLoginKindChoice.vue?vue&type=script&setup=true&lang=ts"

import "./PublicLoginKindChoice.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__